import UploadFileUserIdField from './UploadFileUserIdField'
import withUploadFileUserIdField from './withUploadFileUserIdField'

const ConnectedUploadFileUserIdField = withUploadFileUserIdField(
  UploadFileUserIdField
)

export { ConnectedUploadFileUserIdField as UploadFileUserIdField }
